var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestCaseFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 25.6875C22.8438 25.6875 23.1875 25.3867 23.1875 25V12.625H19.75C18.9766 12.625 18.375 12.0234 18.375 11.25V7.8125L11.5 7.8125C11.1133 7.8125 10.8125 8.15625 10.8125 8.5V25C10.8125 25.3867 11.1133 25.6875 11.5 25.6875H22.5ZM8.75 8.5C8.75 6.99609 9.95312 5.75 11.5 5.75H18.5898C19.3203 5.75 20.0078 6.05078 20.5234 6.56641L24.4336 10.4766C24.9492 10.9922 25.25 11.6797 25.25 12.4102V25C25.25 26.5469 24.0039 27.75 22.5 27.75H11.5C9.95312 27.75 8.75 26.5469 8.75 25V8.5Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestCaseFolder);
export default __webpack_public_path__ + "static/media/test-case-folder.95ba459cdcced8d3caeddb48c4db6920.svg";
export { ForwardRef as ReactComponent };